/* import __COLOCATED_TEMPLATE__ from './thd-tab.hbs'; */
import Component from '@ember/component';
import { service } from '@ember/service';

export default class ThdTab extends Component {
    tagName = '';

    @service('data') model;
    @service toolData;
    @service tabService;

    thdHelpBodyArgs = {};

    init() {
        super.init();

        let colors = this.toolData.data.colors;

        this.thdHelpBodyArgs = {
            freqContainerStyle: this.getLegendStyle(colors.noiseSignal, true),
            sourceContainerStyle: this.getLegendStyle(colors.noiseSource),
            driverContainerStyle: this.getLegendStyle(colors.noiseDriver),
            adcContainerStyle: this.getLegendStyle(colors.noiseAdc),
            systemContainerStyle: this.getLegendStyle(colors.noiseSystem, true),
        };
    }

    getLegendStyle(color, solid) {
        let result = 'padding-left: 15px;';

        if (solid) result += 'border-left: 3px solid ' + color + ';';
        else
            result +=
                'background-image: linear-gradient(to bottom, ' +
                color +
                ' 60%, rgba(255, 255, 255, 0) 0%);' +
                'background-position: left;' +
                'background-size: 2px 16px;' +
                'background-repeat: repeat-y;';

        return result;
    }
}
